
import { request } from '.';
import { storeToken } from 'src/utils/auth';

type PostLoginRequest = {
  username: string;
  password: string;
};

type PostLoginResponse = {
  token: string
}

export async function PostLogin(data: PostLoginRequest) {
  const response = await request.post<PostLoginResponse>("/auth/login", data);
  storeToken(response.data.token); // << salva o token logo após login
  return response;
}

export type UserTokenInfo = {
  user_id: number;
  empresa_id: number;
  name: string;
  email?: string; // presente em tokens novos; usado por gates do EezyGuard
  eezyone_enabled?: boolean; // false = empresa só com EezyGuard (landing EezyOne)
  type: string;
  scp: string[];
  exp: number;
  has_logged: boolean;
  has_changed_password?: boolean; // <- novo campo opcional
};

export const parseJwt = (token: string | null): UserTokenInfo | null => {
  if (!token) {
    return null;
  }

  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export type ForgotPasswordPayload = {
  email: string;
}


export const forgotPassword = async (payload: ForgotPasswordPayload): Promise<void> => {
  const delays = [10000, 15000, 20000]; // ms

  for (let i = 0; i < delays.length; i++) {
    try {
      await request.post("/auth/forgot-password", payload);
      return; // sucesso, sai do loop
    } catch (error) {
      if (i === delays.length - 1) throw error; // última tentativa, propaga o erro
      await new Promise((resolve) => setTimeout(resolve, delays[i]));
    }
  }
}

export type ForgotPasswordChangePayload = {
  code: string;
  token: string;
  new_password: string;
}


export const forgotPasswordChange = async(payload: ForgotPasswordChangePayload): Promise<void> => {
  await request.post("/auth/forgot-password/change", payload)
}
